import { Dashboard as DashboardComponent } from "../design-system/components/dashboard/Dashboard";

export default function DashboardPage() {
  return (
    <DashboardComponent />
  );
}